import React from 'react';
export function ContainsChildrenOfType(children, type) {
    return GetChildrenOfType(children, type).length > 0;
}
export function GetChildrenOfType(children, type) {
    let result = [];
    React.Children.forEach(children, child => {
        if (React.isValidElement(child)) {
            if (child.type === type) {
                result.push(child);
            }
            else if (child.type === React.Fragment) {
                result = result.concat(GetChildrenOfType(child.props.children, type));
            }
        }
    });
    return result;
}
